import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=410e65b5&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=410e65b5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e65b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410e65b5')) {
      api.createRecord('410e65b5', component.options)
    } else {
      api.reload('410e65b5', component.options)
    }
    module.hot.accept("./ReportCard.vue?vue&type=template&id=410e65b5&scoped=true", function () {
      api.rerender('410e65b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/ReportCard.vue"
export default component.exports